
import {Component, Input, ViewChild} from '@angular/core';
import {AdService} from '../providers/ad-service/ad-service';
import {Advertisement} from '../data/advertisement';
import {IonSlides} from '@ionic/angular';

@Component({
    selector: 'advertisements',
    templateUrl: 'advertisement-component.html'
})
export class AdvertisementComponent{

    @Input() advertisements: Advertisement[] = [];
    @Input() transitionDelay: number = 1000;
    @Input() zoom: boolean = true;
    @Input() slidesPerView: number = 1;
    @Input() height: number = 60;

    @ViewChild('slider') slider: IonSlides;

    constructor(){}

    startPlay() {
        try {
            this.slider.startAutoplay();
            // this.slider.startAutoplay = this.transitionDelay;
            // if (this.slider) 
        } catch (e) {
        }
    }
    stopPlay() {
        try {
            this.slider.stopAutoplay();
        } catch (e) {
        }
    }
}